import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const Login = () => {
  const [formData, setFormData] = useState({
    email: "", // Default email untuk kemudahan
    password: "",      // Default password untuk kemudahan
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await axios.post('https://planstopia-production.up.railway.app/api/auth/login', {
        email,
        password,
      });

      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      setLoading(false);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.msg || 'Terjadi kesalahan saat login');
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Panel Kiri dengan Gradient */}
      <div style={styles.leftPanel}>
        <div style={styles.welcomeText}>
          <h1>Welcome !!!</h1>
          <p>Sign In To Your Account</p>
        </div>
        <div style={styles.circle1}></div>
        <div style={styles.circle2}></div>
        <div style={styles.circle3}></div>
      </div>

      {/* Panel Kanan dengan Form Login */}
      <div style={styles.rightPanel}>
        <div style={styles.loginBox}>
          <h2 style={styles.greeting}>Hello! Welcome Admin!</h2>
          <p style={styles.subGreeting}>Login Your Account</p>
          <form onSubmit={onSubmit}>
            <div style={styles.inputGroup}>
              <label htmlFor="email" style={styles.label}>EMAIL ADDRESS</label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={onChange}
                required
                style={styles.input}
              />
            </div>
            <div style={styles.inputGroup}>
              <label htmlFor="password" style={styles.label}>PASSWORD</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                onChange={onChange}
                required
                style={styles.input}
              />
            </div>
            {error && <p style={styles.errorText}>{error}</p>}
            <button type="submit" disabled={loading} style={styles.submitButton}>
              {loading ? 'PROCESSING...' : 'SUBMIT'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

// CSS-in-JS untuk styling halaman login
const styles = {
    container: {
        display: 'flex',
        height: '100vh',
        fontFamily: "'Poppins', sans-serif",
    },
    leftPanel: {
        width: '50%',
        background: 'linear-gradient(45deg, #4e54c8, #8f94fb)',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        overflow: 'hidden',
    },
    welcomeText: {
        textAlign: 'center',
        zIndex: 2,
    },
    circle1: {
        position: 'absolute',
        width: '300px',
        height: '300px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        top: '-50px',
        left: '-100px',
    },
    circle2: {
        position: 'absolute',
        width: '400px',
        height: '400px',
        background: 'rgba(255, 255, 255, 0.15)',
        borderRadius: '50%',
        bottom: '-150px',
        right: '-100px',
    },
     circle3: {
        position: 'absolute',
        width: '150px',
        height: '150px',
        background: 'rgba(255, 255, 255, 0.1)',
        borderRadius: '50%',
        bottom: '50px',
        left: '100px',
    },
    rightPanel: {
        width: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f8f9fa',
    },
    loginBox: {
        width: '360px',
        padding: '40px',
        background: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    },
    greeting: {
        fontSize: '18px',
        fontWeight: 'normal',
        color: '#6c757d',
        margin: '0',
    },
    subGreeting: {
        fontSize: '24px',
        fontWeight: 'bold',
        color: '#343a40',
        marginBottom: '30px',
    },
    inputGroup: {
        marginBottom: '25px',
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontSize: '12px',
        color: '#6c757d',
        fontWeight: 'bold',
    },
    input: {
        width: '100%',
        padding: '12px',
        border: '1px solid #ced4da',
        borderRadius: '4px',
        fontSize: '14px',
    },
    errorText: {
        color: '#dc3545',
        textAlign: 'center',
        marginBottom: '15px',
        fontSize: '14px',
    },
    submitButton: {
        width: '100%',
        padding: '15px',
        background: 'linear-gradient(45deg, #4e54c8, #8f94fb)',
        color: 'white',
        border: 'none',
        borderRadius: '4px',
        cursor: 'pointer',
        fontSize: '16px',
        fontWeight: 'bold',
        transition: 'opacity 0.2s',
    }
};

export default Login;
